<template>
  <div v-if="userInfoList && userInfoList.length">
    <el-table :data="userInfoList">
      <el-table-column prop="name" label="姓名" width="170"> </el-table-column>
      <el-table-column prop="ghxh" label="工号/学号" width="160">
      </el-table-column>
      <el-table-column fixed="right" label="操作"   style="width: 10%;">
        <template slot-scope="scope">
          <el-button @click="editUser(scope.row._id)" type="text" size="small"
            >编辑</el-button
          >
          <el-button @click="deleteUser(scope.row._id)" type="text" size="small"
            >删除</el-button
          >
          <el-button @click="cancelAdmin(scope.row._id)" type="text" size="small">取消设置管理员</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div v-else>
    <p>nothing</p>
  </div>

  
</template>

<script>
export default {
  data() {
    return {
      userInfoList: [], // 存储人员信息列表
      userInfo: null,
      userId: ''
    };
  },
  created() {
    this.userId = this.$route.params.id;

    if (this.userId && this.userId !== ':id') {
      this.fetchUserInfo(this.userId);
    } else {
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        const userId = to.params.id;
        if (userId) {
          this.fetchUserInfo(userId);
        }
        this.fetchUserForms(); // 在路由变化时也重新获取用户列表
      },
    },
  },
  methods: {
    goToUserSetting(userId) {
      if (!userId) {
        console.error('无效的用户ID:', userId);
        return;
      }
      this.$router.push({ name: 'UserSetting', params: { id: userId } });
    },
    async fetchUserInfo(userId) {
      try {
        if (!userId || userId === ':id') {
          return;
        }

        const response = await this.$http.get(
          `UserForm/${encodeURIComponent(userId)}`
        );

        // 增加调试信息

        if (response.data) {
          const { _id, name, ...rest } = response.data;

          if (_id && name) {
            this.userInfo = response.data;
            console.log('获取到的用户信息:', this.userInfo);
          } else {
            console.error('响应数据缺少必要字段:', response.data);
            this.$message.error("响应数据缺少必要字段");
          }
        } else {
        }
      } catch (error) {
        console.error("获取人员信息失败:", error);
        this.$message.error("获取人员信息失败，请重试");
      }
    },
    fetchUserForms() {
      this.$http
        .get("UserForm")
        .then((res) => {
          if (res && Array.isArray(res)) {
            this.userInfoList = res; // 更新 userInfoList 数据
          } else {
            console.error('无效的响应数据:', res);
          }
        })
        .catch((err) => {
          console.error("获取人员列表失败:", err);
        });
    },

    cancelAdmin(id) {
      if (confirm("确定要取消该人员的管理员设置吗？")) {
        // 这里可以发送一个请求到后端，取消该人员的管理员设置
        this.$http
          .post(`UserForm/cancelAdmin/${id}`)
          .then(() => {
            // 从当前页面的列表中移除该人员
            this.userInfoList = this.userInfoList.filter(user => user._id !== id);
            this.$message({
              message: "取消管理员设置成功",
              type: "success"
            });
          })
          .catch((error) => {
            console.error("取消管理员设置失败:", error);
            this.$message.error("取消管理员设置失败，请重试");
          });
      }
    },

    editUser(id) {
      this.$router.push(`/user/${id}/edit`);
    },

    deleteUser(id) {
      if (confirm("确定要删除该人员信息吗(会将该人员在人员列表内删除)?")) {
        this.$http
          .delete(`UserForm/${id}`)
          .then(() => {
            this.$router.push("/user/list");
          })
          .catch((error) => {
            console.error("删除人员信息失败:", error);
          });
      }
    },
  },
};
</script>